import { client }  from '../util/createRestApiClient';
import { loading } from "./index";

const base = "Seniority/";
export default () => ({

    getSeniorityList: (limit = 10, skip = 0, columnSort = "", descending = true, fileNo = "", lastName = "") => loading(client.request({
      method: 'GET',
      url: base + 'GetSeniorityAll?limit=' + limit + '&skip=' + skip + '&columnSort=' + columnSort + '&descending=' + descending + '&fileNo=' + fileNo + '&lastName=' + lastName
    })),
    importSeniority: (params) => client.request({
      method: 'POST',
      url: base + 'ImportSeniority/',
      data: params
    }),
    deleteSeniority: () => loading(client.request({
      method: 'DELETE',
      url: base + 'Delete/'
    }))
  }
);